import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder"
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css"
import mapboxgl from "mapbox-gl"
import "mapbox-gl/dist/mapbox-gl.css"
import React, { useEffect, useRef, useState } from "react"
import * as styles from "./FormAddress.module.scss"

const NEXT_PUBLIC_MAPBOX_API_PK = process.env.NEXT_PUBLIC_MAPBOX_API_PK

const FormAddress = ({ data, handleAddressUpdate }) => {
  const [address, setAddress] = useState("")

  const [map, setMap] = useState(null)
  const mapContainer = useRef(null)

  useEffect(() => {
    mapboxgl.accessToken = NEXT_PUBLIC_MAPBOX_API_PK
    const startCoordinates = data.addresscoordinates
      ? [data.addresscoordinates.longitude, data.addresscoordinates.latitude]
      : [-0.1187, 51.5077]

    const initializeMap = ({ setMap, mapContainer }) => {
      const map = new mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/mapbox/streets-v11",
        center: startCoordinates,
        zoom: data.addresscoordinates ? 14 : 11,
      })

      map.on("load", () => {
        setMap(map)
        map.resize()
      })
      const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl,
      })
      map.addControl(geocoder)

      if (data.address) {
        geocoder.query(data.address)
      }

      geocoder.on("result", ({ result }) => {
        const addressFields = {
          address: result.place_name,
          addressstreet1: `${result.address ? result.address : ""} ${result.text}`,
          addresscoordinates: {
            longitude: result.center[0],
            latitude: result.center[1],
          },
        }

        for (const item of result.context) {
          switch (item.id.substring(0, item.id.indexOf("."))) {
            case "postcode":
              addressFields.addresspostcode = item.text
              break
            case "place":
              addressFields.addresscity = item.text
              break
            case "country":
              addressFields.addresscountry = item.text
              break

            case "locality":
              addressFields.addressstreet2 = item.text
              break

            default:
              break
          }
        }

        handleAddressUpdate(addressFields)

        setAddress(result.place_name)
      })
      geocoder.on("clear", (el) => {
        setAddress("")
        handleAddressUpdate({
          address: null,
          addressstreet1: null,
          addressstreet2: null,
          addresscity: null,
          addresspostcode: null,
          addresscountry: null,
          addresscoordinates: null,
        })
      })
    }
    if (!map) initializeMap({ setMap, mapContainer })
  }, [])

  return (
    <section className={styles.FormAddress}>
      <h3>Address</h3>
      <p>Please input your business address here</p>
      <div className={styles.mapContainer}>
        <div ref={mapContainer} className={styles.map} />
        <input
          id="address"
          name="address"
          value={address}
          required
          className={styles.hiddenInput}
          readOnly
        />
      </div>
    </section>
  )
}

export default FormAddress
